import React from "react";
import chevronRight from "../../assets/chevron_right.svg";
import "./banner.css";
// import bannerimg from "../../assets/banner-image.svg"
import screVideo from "../../assets/banner-video.mp4";

const BannerSection = () => {
  return (
    <section className="banner-section">
      <div className="container">
        <div className="banner-wrapper">
          <div className="banner-tag">
            <span>NEW</span>
            <p>Click here for more information</p>
            <div className="banner-tag-arrow">
              <img src={chevronRight} alt="arrow" />
            </div>
          </div>
          <h1>Agentic AI for Incident Management and Observability 3.0</h1>
          <p>
            AgentSRE is built for enterprises that can’t afford downtime. A
            fleet of AI agents automates detection, root cause analysis, and
            remediation - delivering faster recovery, lower cloud costs, and
            resilient operations
          </p>
          <div className="banner-button">
            {/* <a href="">Get Started</a> */}
            <a href="https://demo.elixirdata.co/">Request For Demo</a>
          </div>
          <video className="VideoTag" autoPlay muted loop playsInline>
            <source src={screVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      {/* <img src={bannerimg} className="banner-img" alt="banner-image" /> */}
    </section>
  );
};

export default BannerSection;
